import { render } from "./postitem.vue?vue&type=template&id=115ea4b0"
import script from "./postitem.vue?vue&type=script&lang=js"
export * from "./postitem.vue?vue&type=script&lang=js"

import "./postitem.vue?vue&type=style&index=0&id=115ea4b0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__